export const supportedCurrencies = [
  'USD',
  'AUD',
  'BRL',
  'CAD',
  'CHF',
  'CZK',
  'DKK',
  'EUR',
  'GBP',
  'HKD',
  'HUF',
  'ILS',
  'JPY',
  'MXN',
  'MYR', // Only supported for MY countries. Should be disabled is user is not in MY.
  'NOK',
  'NZD',
  'PHP',
  'PLN',
  // Disable RUB for sanctions
  // 'RUB',
  'SEK',
  'SGD',
  'THB',
  'TWD'
];

type CurrencyValidation = {
  min: number;
  max?: number;
};

type ValidationMap = {
  default: CurrencyValidation;
  [currency: string]: CurrencyValidation;
};

// Extract common configurations to reduce redundancy
const commonValidations: Record<string, CurrencyValidation> = {
  USD: {
    min: 1,
    max: 100000
  },
  // we've decided to not support non-two decimal currencies
  decimalCurrencies: {
    min: 0.01
  },
  nonDecimalCurrencies: {
    min: 1
  }
};

export const amountValidations: Record<'v1' | 'v2', Record<string, CurrencyValidation>> = {
  v1: {
    default: {
      min: 1
    },
    USD: commonValidations.USD
  },
  v2: {
    decimalCurrencies: commonValidations.decimalCurrencies,
    nonDecimalCurrencies: commonValidations.nonDecimalCurrencies,
    USD: commonValidations.USD
  }
};

export const shippingValidations: ValidationMap = {
  default: {
    min: 0
  },
  USD: {
    min: 0,
    max: 10000
  }
};

export const handlingValidations: ValidationMap = {
  default: {
    min: 0
  },
  USD: {
    min: 0,
    max: 100000
  }
};
